import i18n from 'i18next';

export const ALL_INSTITUTIONS = {
	uuid: 'all',
	name: i18n.t('vod_section_details_all_institutions')
};
